import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { RegistrationService } from '../../services/registration/registration.service';
import { User } from 'netsocial-lib/src/app/interfaces/user';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';
import { ErrorService } from 'netsocial-posting/src/app/services/error/error.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage {
  currentUser: User;
  _form: UntypedFormGroup;
  passwordStrength: number | null;
  password = '';
  verifyPassword = '';

  constructor(
    private readonly userService: UserService,
    private readonly registrationService: RegistrationService,
    private readonly errorService: ErrorService
  ) {
    this.currentUser = this.userService.currentUser!;

    this._form = new UntypedFormGroup({
      password: new UntypedFormControl(
        this.registrationService.newUser?.password,
        Validators.required
      ),
      verifiedPassword: new UntypedFormControl(
        this.registrationService.newUser?.password,
        Validators.required
      ),
    });
  }

  passwordStrengthChange(passwordStrength: number | null): void {
    this.passwordStrength = passwordStrength;
  }

  async savePassword(): Promise<void> {
    try {
      await this.userService.setTeamMember({
        id: this.currentUser.id,
        password: this.password,
      });

      this.errorService.toastMessage('workspace.settings.changePassword.success');
    } catch (error) {
      this.errorService.toastError('workspace.settings.changePassword.errors.save');
    }
  }
}
